import parse from "html-react-parser";

import type { TagProps } from "./interface";
import { TagWrapper } from "./style";

const Tag = ({ text, color }: TagProps) => {
  return (
    <span>
      <TagWrapper color={color} className="text-nowrap">
        {parse(text)}
      </TagWrapper>
    </span>
  );
};

export default Tag;
